export default {"src":"/_next/static/media/accelerometer-readings.f6ebc650.gif","height":600,"width":1347,"blurWidth":0,"blurHeight":0};